import { Component, Input, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { Table } from '@openng/optimus-ui/table';
import { UserService } from './user.service';

@Component({
    selector: 'app-userlogs',
    templateUrl: './userlogs.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UserLogsComponent {
    @Input() user: string;
    events: any = [];

    @ViewChild('dtp') table: Table;

    constructor(private userService: UserService) {}

    ngOnInit() {
        console.log('load logs');
        this.load_logs();
    }

    ngOnDestroy(): void {}

    load_logs() {
        if (!this.user) {
            return;
        }
        this.userService.getUserLogs(this.user).subscribe(
            (resp) => (this.events = (<any[]>resp).reverse()),
            (err) => console.log('failed to get events')
        );
    }
}
